module.exports = __webpack_public_path__ + "img/simon_zsuzsi_after_bathing_small.72e5b4fe.jpg";